import { AppPageHeader } from '@/components/_common';
import { ExtraFiltersProps } from '@/types/ExtraFiltersProps';
import { Button } from 'antd';

import { useIntl } from 'react-intl';
import { ResourceLimitationPeriodsListQuery } from '@/core/domain/enterprise/ResourceLimitationPeriods/ResourceLimitationPeriods.types';
import CompanyResourceLimitationPeriodsExtraFilters from './CompanyResourceLimitationPeriodsExtraFilters';

export default function CompanyResourceLimitationPeriodsFilters({
  queryParams,
  setQueryParams,
}: ExtraFiltersProps<ResourceLimitationPeriodsListQuery>) {
  const intl = useIntl();

  return (
    <AppPageHeader
      onSearch={(value) =>
        setQueryParams((prev) => ({ ...prev, description: value }))
      }
      searchValue={queryParams?.description}
      extraFilters={
        <CompanyResourceLimitationPeriodsExtraFilters
          queryParams={queryParams}
          setQueryParams={setQueryParams}
        />
      }
      headerActions={({ isShowingFilters }: { isShowingFilters: boolean }) =>
        isShowingFilters && (
          <Button
            type="primary"
            onClick={() => setQueryParams({ order: 'ASC' })}
          >
            {intl.formatMessage({ id: 'commons.clear.filters' })}
          </Button>
        )
      }
    />
  );
}
